import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { AuthGuard } from '../service/auth/auth.guard';
import { ProfileResolver } from '../service/auth/profile.resolver';

export const settingsRoutes: Routes = [
    {
        path: '',
        component: SettingsPageComponent,
        canActivate: [
            AuthGuard,
        ],
        resolve: {
            profile: ProfileResolver,
        },
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(settingsRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class SettingsRoutingModule {
}
